import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Link, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
// import "./ClientDetails.scss"
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
import LocationDetail from "../../../../../Components/Broker/LocationDetail/LocationDetail";
import LogsTable from "../../../../../Components/Broker/LogsTable/LogsTable";
import SpocTable from "../../../../../Components/Broker/SPOCTable/SpocTable";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import "../../../../../formLayout.scss";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import SelectDropdownDisable from "../../../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
import LocationPopup from "./ClientDetailsPopup/LocationPopup";

function ClientDetails() {
  const navigate = useNavigate();
  const [organization, setOrganization] = React.useState("Evervent");
  const [ownership, setOwnership] = React.useState("Private Limited");
  const [industry, setIndustry] = React.useState("Business Development");
  const [subindustry, setSubIndustry] = React.useState("Management");
  const [organizationEmail, setOrganizationEmail] =
    React.useState("abc@gmail.com");
  const [organizationPhoneNumber, setOrganizationPhoneNumber] =
    React.useState("9876543210");
  const [taxID, setTaxID] = React.useState("23ER4567");
  const [companyID, setCompanyID] = React.useState("EV-20356");
  const [webDomains, setWebDomains] = React.useState("");
  const [websiteURL, setWebsiteURL] = React.useState("www.evervent.com");
  const [locationName, setLocationName] = React.useState("Mohali");
  const [locationType, setLocationType] = React.useState("Head Office");
  const [streetName, setStreetName] = React.useState(
    "Phase-9, Industrial Area"
  );
  const [areaName, setAreaName] = React.useState("Mohali");
  const [country, setCountry] = React.useState("India");
  const [state, setState] = React.useState("Punjab");
  const [city, setCity] = React.useState("Mohali");
  const [zipCode, setZipCode] = React.useState("160022");
  const [productTabsStatus, setProductTabsStatus] = React.useState("overview");
  const [locationPopup, setLocationPopup] = React.useState(false);
  const [parentOrg, setParentOrg] = React.useState("");
  const [toggle, setToggle] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] = React.useState<string>(
    "personalDetailsSection"
  );
  const [subSection, setSubSection] = React.useState<string>("basics");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [emailcomp, setEmailComp] = React.useState(false);
  const [locationDetail, setLocationDetail] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [file, setFile] = React.useState("");

  const handleClick = () => {
    setToggle(!toggle);
  };

  const ownership_data = [
    { key: "Private Limited", value: "Private Limited" },
    { key: "Partnership", value: "Partnership" },
  ];
  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const parentOrg_data = [
    { label: "CLT012 - Evervent", value: "CLT012 - Evervent" },
    { label: "CLT013 - Evervent", value: "CLT013 - Evervent" },
    { label: "CLT014 - Evervent", value: "CLT014 - Evervent" },
    { label: "CLT015 - Evervent", value: "CLT015 - Evervent" },
  ];
  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];

  // const updateMasterState = (attrName: any, value: any) => {
  //     attrName(value);
  // };

  const [locationData, setLocationData] = React.useState([
    {
      companyName: "",
      locationType: "",
      companyAddress: "",
      spoc: "",
      activePolicies: "",
      actionBtn: "",
    },
  ]);
  const [attachmentData, setAttachmentData] = React.useState([
    {
      fileName: "",
      date: "",
      time: "",
    },
  ]);
  const [emailData, setEmailData] = React.useState([
    {
      check_status: "",
      sender_person_tag: "",
      from_person: "",
      email_subject: "",
      recipients: "",
      date: "",
      time: "",
      action_btn1: "",
      action_btn2: "",
    },
  ]);
  const [logsData, setLogsData] = React.useState([
    {
      log_creation_time: "",
      log_creation_date: "",
      log_activty: "",
      field: "",
      log_desc: "",
      type: "",
    },
  ]);
  const [userData, setUserData] = React.useState([
    {
      username: "",
      roletype: "",
      creationdate: "",
      creationtime: "",
      actionbtn1: "",
      actionbtn2: "",
    },
  ]);

  useEffect(() => {
    setLocationData([
      {
        companyName: "Evervent",
        locationType: "Registered Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Head Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "RnD Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Front Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Head Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
    ]);
    setAttachmentData([
      {
        fileName: "621c94f41153e1835257b41b_lead mockup.webp",
        date: "30 Nov, 2022",
        time: "11:00 AM",
      },
      {
        fileName: "621c94f41153e1835257b41b_lead mockup.webp",
        date: "30 Nov, 2022",
        time: "11:00 AM",
      },
    ]);
    setEmailData([
      {
        check_status: "",
        sender_person_tag: "AS",
        from_person: "Ankit Sachdeva",
        email_subject: "Automation Enhancements and ...",
        recipients: "Umesh Gemini, Karan Joshi",
        date: "23 Dec, 2022",
        time: "11:00 AM",
        action_btn1: "images/email_attachment_icon.svg",
        action_btn2: "images/email_action_icon.svg",
      },
      {
        check_status: "",
        sender_person_tag: "RR",
        from_person: "Rahul Raghuvanshi",
        email_subject: "Automation Enhancements and ...",
        recipients: "Umesh Gemini, Karan Joshi",
        date: "23 Dec, 2022",
        time: "11:00 AM",
        action_btn1: "images/email_attachment_icon.svg",
        action_btn2: "images/email_action_icon.svg",
      },
    ]);
    setLogsData([
      {
        log_creation_time: "11:00PM",
        log_creation_date: "23 Nov, 2022",
        log_activty: "Change SPOC Detail",
        field: "Email Id",
        log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
        type: "Modification",
      },
      {
        log_creation_time: "11:00PM",
        log_creation_date: "23 Nov, 2022",
        log_activty: "Change SPOC Detail",
        field: "Email Id",
        log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
        type: "Modification",
      },
      {
        log_creation_time: "11:00PM",
        log_creation_date: "23 Nov, 2022",
        log_activty: "Change SPOC Detail",
        field: "Email Id",
        log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
        type: "Modification",
      },
      {
        log_creation_time: "11:00PM",
        log_creation_date: "23 Nov, 2022",
        log_activty: "Change SPOC Detail",
        field: "Email Id",
        log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
        type: "Modification",
      },
    ]);
    setUserData([
      {
        username: "Satish",
        roletype: "Admin",
        creationdate: "23-12-2022",
        creationtime: "17:45 hrs",
        actionbtn1: "images/delete_icon.svg",
        actionbtn2: "images/edit_icon.svg",
      },
      {
        username: "jennifer",
        roletype: "Relationship Manager",
        creationdate: "23-12-2022",
        creationtime: "17:45 hrs",
        actionbtn1: "images/delete_icon.svg",
        actionbtn2: "images/edit_icon.svg",
      },
      {
        username: "Umesh",
        roletype: "Operations Manager",
        creationdate: "23-12-2022",
        creationtime: "17:45 hrs",
        actionbtn1: "images/delete_icon.svg",
        actionbtn2: "images/edit_icon.svg",
      },
    ]);
  }, []);

  // for scrolling
  const personalDetailsSection = useRef(null);

  const basics = useRef(null);
  const registeredAddress = useRef(null);
  const attatchmentsSection = useRef(null);
  const locationsSection = useRef(null);
  const emailSection = useRef(null);
  const taskSection = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  //for policy Tab Table Data
  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "policy_id",
      headerName: "Policy ID",
      width: 170,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/PolicyDetail");
            }}
          >
            EPZ08665R56456
          </Link>
        );
      },
    },
    {
      field: "client_name",
      headerName: "Client Name",
      width: 220,
      check_status: true,
    },
    {
      field: "client_id",
      headerName: "Client ID",
      width: 150,
      check_status: true,
    },
    {
      field: "policy_type",
      headerName: "Policy Type",
      width: 200,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      width: 180,
      check_status: true,
    },
    {
      field: "policynumber",
      headerName: "Policy Number",
      width: 180,
      check_status: true,
    },
    {
      field: "start_date",
      headerName: "Policy Start Date",
      width: 130,
      check_status: true,
    },
    {
      field: "end_date",
      headerName: "Policy End Date",
      width: 130,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "nol",
      headerName: "No.of Lives",
      width: 100,
      check_status: true,
    },
    {
      field: "noe",
      headerName: "No. of Employees",
      width: 150,
      check_status: true,
    },
    {
      field: "sum_assured",
      headerName: "Sum Insured/Assured",
      width: 180,
      check_status: true,
    },
    {
      field: "cdbal",
      headerName: "CD Balance",
      width: 130,
      check_status: true,
    },
    {
      field: "premium",
      headerName: "Premium",
      width: 130,
      check_status: true,
    },
    {
      field: "branch_location",
      headerName: "Locations",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 1,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 2,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 3,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 4,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 5,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
  ];

  //for contact Tab Table Data
  const [contactColumns, setContactColumns] = React.useState([
    {
      field: "name",
      headerName: "Name",
      width: 200,
      check_status: true,
    },
    {
      field: "organization",
      headerName: "Organization",
      width: 200,
      check_status: true,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 120,
      check_status: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      check_status: true,
    },
    {
      field: "office_phone",
      headerName: "Office Phone",
      width: 120,
      check_status: true,
    },
    {
      field: "office_email",
      headerName: "Office Email",
      width: 200,
      check_status: true,
    },
    {
      field: "current_job_title",
      headerName: "Current Job Title",
      width: 200,
      check_status: true,
    },
    {
      field: "current_employer",
      headerName: "Current Employer",
      width: 200,
      check_status: true,
    },
  ]);
  const contactRows = [
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      organization: "Evervent",
      mobile: "98765 43210",
      email: "company@domain.com",
      office_phone: "123456",
      office_email: "company@domain.com",
      current_job_title: "AVP",
      current_employer: "Evervent",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      organization: "Evervent",
      mobile: "98765 43210",
      email: "company@domain.com",
      office_phone: "123456",
      office_email: "company@domain.com",
      current_job_title: "AVP",
      current_employer: "Evervent",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      organization: "Evervent",
      mobile: "98765 43210",
      email: "company@domain.com",
      office_phone: "123456",
      office_email: "company@domain.com",
      current_job_title: "AVP",
      current_employer: "Evervent",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      organization: "Evervent",
      mobile: "98765 43210",
      email: "company@domain.com",
      office_phone: "123456",
      office_email: "company@domain.com",
      current_job_title: "AVP",
      current_employer: "Evervent",
    },
  ];

  //for subsidiary list data
  const [subsidiaryListColumns, setSubsidiaryListColumns] = React.useState([
    {
      field: "name",
      headerName: "Name",
      width: 200,
      check_status: true,
    },
    {
      field: "industry",
      headerName: "Industry",
      width: 200,
      check_status: true,
    },
    {
      field: "sub_industry",
      headerName: "Sub Industry",
      width: 200,
      check_status: true,
    },
    {
      field: "registered_address",
      headerName: "Registered Address",
      width: 500,
      check_status: true,
    },
    {
      field: "tax_id",
      headerName: "Tax ID",
      width: 100,
      check_status: true,
    },
    {
      field: "company_id",
      headerName: "Company ID",
      width: 150,
      check_status: true,
    },
    {
      field: "spoc",
      headerName: "SPOC",
      width: 250,
      check_status: true,
    },
    {
      field: "organization_email",
      headerName: "Organization Email",
      width: 250,
      check_status: true,
    },
    {
      field: "organization_phone_number",
      headerName: "Org. Phone Number",
      width: 200,
      check_status: true,
    },
    {
      field: "active",
      headerName: "Active",
      width: 100,
      check_status: true,
    },
  ]);
  const subsidiaryListRows = [
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      industry: "IT",
      sub_industry: "Kotal Mahindra",
      registered_address: "123,area, phase, city, state, country - 123456",
      tax_id: "123456",
      company_id: "56489465",
      spoc: "CNT-1234 - Suveshi ",
      organization_email: "company@domain.com",
      organization_phone_number: "98765 43210",
      active: "5",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      industry: "IT",
      sub_industry: "Kotal Mahindra",
      registered_address: "123,area, phase, city, state, country - 123456",
      tax_id: "123456",
      company_id: "56489465",
      spoc: "CNT-1234 - Suveshi ",
      organization_email: "company@domain.com",
      organization_phone_number: "98765 43210",
      active: "5",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      industry: "IT",
      sub_industry: "Kotal Mahindra",
      registered_address: "123,area, phase, city, state, country - 123456",
      tax_id: "123456",
      company_id: "56489465",
      spoc: "CNT-1234 - Suveshi ",
      organization_email: "company@domain.com",
      organization_phone_number: "98765 43210",
      active: "5",
    },
    {
      id: 0,
      name: "Rahul Raghuvanshi",
      industry: "IT",
      sub_industry: "Kotal Mahindra",
      registered_address: "123,area, phase, city, state, country - 123456",
      tax_id: "123456",
      company_id: "56489465",
      spoc: "CNT-1234 - Suveshi ",
      organization_email: "company@domain.com",
      organization_phone_number: "98765 43210",
      active: "5",
    },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <LocationPopup
        open_status={locationPopup}
        attrName={setLocationPopup}
        value_update={updateMasterState}
      />
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=clients");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">E</span>
          <div>
            <h3>Evervent Pvt. Ltd.</h3>
            <p>CN0001 - Created on 12th Nov, 2022</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Add New">
              <Link
                className="actionLinks"
                onClick={() => {
                  //navigate("/AddNewQuotess");
                }}
              >
                <PostAddIcon />
              </Link>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Global Edit">
              <Link
                className="actionLinks"
                onClick={() => {
                  navigate("/AddNewQuotess");
                }}
              >
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetailsSection"
                    ? "active sectionLink personalDetailsSection"
                    : "sectionLink personalDetailsSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(personalDetailsSection);
                  SetSectionStatus("personalDetailsSection");
                }}
              >
                <span> Personal Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basics"
                        ? "inner_link active basics"
                        : "inner_link  basics"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(basics);
                      setSubSection("basics");
                    }}
                  >
                    Basic Info
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      subSection === "registeredAddress"
                        ? "inner_link active registeredAddress"
                        : "inner_link  registeredAddress"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(registeredAddress);
                      setSubSection("registeredAddress");
                    }}
                  >
                    Registered Address
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "locationsSection"
                    ? "active sectionLink locationsSection"
                    : "sectionLink locationsSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(locationsSection);
                  SetSectionStatus("locationsSection");
                }}
              >
                <span> Location Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "attatchmentsSection"
                    ? "active sectionLink attatchmentsSection"
                    : "sectionLink attatchmentsSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsSection);
                  SetSectionStatus("attatchmentsSection");
                }}
              >
                <span> Attatchment</span>
              </Link>
              <Link
                className={
                  sectionStatus === "emailSection"
                    ? "active sectionLink emailSection"
                    : "sectionLink emailSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(emailSection);
                  SetSectionStatus("emailSection");
                }}
              >
                <span> Email</span>
              </Link>
              <Link
                className={
                  sectionStatus === "taskSection"
                    ? "active sectionLink taskSection"
                    : "sectionLink taskSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(taskSection);
                  SetSectionStatus("taskSection");
                }}
              >
                <span> Task</span>
              </Link>
            </Grid>
            <Grid
              xs
              className="rightSection h-100"
              sx={{ overflowX: "hidden" }}
            >
              <Grid container spacing={1} sx={{ alignItems: "center" }}>
                <Grid lg={7} md={9} xs={12} className="text-sm-center">
                  <div className="productTabs">
                    <Button
                      className={
                        productTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        productTabsStatus == "policies"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("policies");
                      }}
                    >
                      Policies
                    </Button>
                    <Button
                      className={
                        productTabsStatus == "subsidiaries"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("subsidiaries");
                      }}
                    >
                      Subsidiaries
                    </Button>
                    <Button
                      className={
                        productTabsStatus == "contacts"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("contacts");
                      }}
                    >
                      Contacts
                    </Button>
                    <Button
                      className={
                        productTabsStatus == "logs"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("logs");
                      }}
                    >
                      Logs
                    </Button>
                    <Button
                      className={
                        productTabsStatus == "settings"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setProductTabsStatus("settings");
                      }}
                    >
                      Settings
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={3}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                  alignSelf="center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>

              {productTabsStatus == "overview" ? (
                <>
                  <Grid container className="mb-1">
                    <Grid xs={12}>
                      <div className="client_info_section">
                        <p className="client_info_p empID md_width">
                          Client ID : <span>CL00001</span>
                        </p>
                        <p className="client_info_p totalEmployees md_width">
                          Total Employees: <span>50</span>
                        </p>
                        <p className="client_info_p totalEmployees md_width mr-0">
                          Total Locations: <span>05</span>
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                  <Box className="upload-logo">
                    <Grid container spacing={3} className="mb-3">
                      <Grid xs={12}>
                        <img
                          src={
                            file.length > 0
                              ? file
                              : "images/preview-logo-img.svg"
                          }
                          alt=""
                          className="upload_company_logo add_logo"
                        />
                        <Link className="upload_img" component="label">
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleChange}
                          />

                          <img src="images/upload_logo_icon.svg" alt="" />
                          <span>Add logo</span>
                        </Link>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    className="detailSection"
                    ref={personalDetailsSection}
                    margin="0px 12px"
                  >
                    <div ref={basics}>
                      <div className="sectionTitle">
                        <h4>Personal Details</h4>
                      </div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic Info</h5>
                        </Grid>
                      </Grid>

                      {/* <Grid container spacing={3}>
                        <Grid xs={12} className="mb-3">
                          <Button
                            className="add_logo greenBtn addfile"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              multiple
                              type="file"
                              onChange={handleChange}
                            />
                            <span>Add Logo</span>
                            <img src={file} className="uploadimage" />
                          </Button>

                          <Link  className="editlogo">
                            Change Logo
                          </Link>
                        </Grid>
                      </Grid> */}

                      <Grid container spacing={3}>
                        <Grid xs={6} lg={6}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Organization"
                            value={organization}
                            attrName={setOrganization}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={6}>
                          <SelectDropdownDisable
                            class_name="inputField"
                            title="Ownership"
                            value={ownership}
                            attrName={setOwnership}
                            value_update={updateMasterState}
                            dropdown_data={ownership_data}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} lg={4}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="Industry"
                            value={industry}
                            attrName={setIndustry}
                            value_update={updateMasterState}
                            data={industry_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={6} lg={4}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="Sub-Industry"
                            value={subindustry}
                            attrName={setSubIndustry}
                            value_update={updateMasterState}
                            data={subindustry_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Organization Email"
                            value={organizationEmail}
                            attrName={setOrganizationEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Organization Phone Number"
                            value={organizationPhoneNumber}
                            attrName={setOrganizationPhoneNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Tax ID"
                            value={taxID}
                            attrName={setTaxID}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Company ID"
                            value={companyID}
                            attrName={setCompanyID}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Website URL"
                            value={websiteURL}
                            attrName={setWebsiteURL}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Domains for the Company"
                            value={webDomains}
                            attrName={setWebDomains}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div ref={registeredAddress}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Registered Address Info
                          </h5>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3}>
                        <Grid xs={6} lg={5}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Location Name"
                            value={locationName}
                            attrName={setLocationName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={5}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Location type"
                            value={locationType}
                            attrName={setLocationType}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} lg={6}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Building/Street Name"
                            value={streetName}
                            attrName={setStreetName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={6}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="State"
                            value={state}
                            attrName={setState}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="City"
                            value={city}
                            attrName={setCity}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Zip Code"
                            value={zipCode}
                            attrName={setZipCode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box
                    className="detailSection"
                    ref={locationsSection}
                    margin="0px 12px"
                  >
                    <div className="sectionTitle">
                      <h4>Location Details </h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setLocationPopup(true);
                          }}
                        >
                          Add Location
                        </Link>
                      </div>
                    </div>

                    {/* Location section start */}
                    <Grid container spacing={3}>
                      <Grid xs={12} sx={{ padding: "0" }}>
                        <LocationDetail
                          open_status={locationDetail}
                          attrName={setLocationDetail}
                          value_update={updateMasterState}
                        />
                      </Grid>
                    </Grid>

                    {/* Location section end */}
                  </Box>

                  <Box
                    className="detailSection"
                    margin="0px 12px"
                    ref={attatchmentsSection}
                  >
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>

                    {/* Attachment Section Start*/}
                    <Grid container spacing={3}>
                      <Grid xs={12} sx={{ padding: "0" }}>
                        <Attachment
                          open_status={attachment}
                          attrName={setAttachment}
                          value_update={updateMasterState}
                        />
                      </Grid>
                    </Grid>
                    {/* Attachment Section End*/}
                  </Box>

                  <Box
                    className="detailSection"
                    ref={emailSection}
                    margin="0px 12px"
                  >
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                  </Box>
                  {/* Task Section start */}
                  <Box
                    className="detailSection"
                    ref={taskSection}
                    margin="0px 12px"
                  >
                    <div className="sectionTitle">
                      <h4>Tasks </h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <div className="mx-3">
                      <TasksSection />
                    </div>
                  </Box>

                  {/* redundant code  will delete late */}
                </>
              ) : null}

              {productTabsStatus == "policies" ? (
                <>
                  <Grid xs={12} className="detailBox mb-5">
                    <Grid container padding="0">
                      <Grid xs={12}>
                        <div style={{ height: "100%", width: "100%" }}>
                          <UGTable
                            header_data={columns}
                            data={rows}
                            value_update={updateMasterState}
                            attrName={"UGTable"}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null}

              {productTabsStatus == "subsidiaries" ? (
                <>
                  <Box>
                    <Grid xs={12} padding="12px">
                      <Grid container>
                        <Grid
                          xs={12}
                          className="switchFields detailSection"
                          display={"flex"}
                          alignItems="center"
                        >
                          <span>Is this a Subsidiary Organization ?</span>
                          <input
                            type="checkbox"
                            className="switch"
                            onClick={handleClick}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {toggle == false ? (
                      <Grid xs={12} className="detailBox2 mb-5">
                        <Box className="detailSection">
                          <div className="sectionTitle">
                            <h4>Subsidiary Organization List </h4>

                            <div className="actionBtns">
                              <Link
                                className="redBtn delete"
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              >
                                Delete
                              </Link>
                            </div>
                          </div>

                          <Grid container>
                            <Grid xs={12} className="innerDetailBox">
                              <Grid container>
                                <Grid xs={12}>
                                  <div
                                    style={{
                                      height: "400px",
                                      width: "100%",
                                    }}
                                  >
                                    <UGTable
                                      header_data={subsidiaryListColumns}
                                      data={subsidiaryListRows}
                                      value_update={updateMasterState}
                                      attrName={"UGTable"}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    ) : (
                      <>
                        <Grid xs={4} className="mb-3">
                          <SearchDropdown
                            class_name="inputField"
                            title="Parent Organization Name"
                            value={parentOrg}
                            attrName={setParentOrg}
                            value_update={updateMasterState}
                            data={parentOrg_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={12} className="detailBox2">
                          <Box className="detailSection">
                            <div className="sectionTitle mb-0">
                              <h4>Parent Organization Details</h4>
                              <div className="actionBtns">
                                <Link
                                  className="blueBtn edit"
                                  onClick={() => {
                                    //   setopenEmail(true);
                                  }}
                                  sx={{
                                    textDecoration: "none",
                                  }}
                                >
                                  Change
                                </Link>
                              </div>
                            </div>
                            <Grid container className="ParentOrgSection">
                              <Grid xs={6} xl={3}>
                                <p className="sm-font">
                                  Name
                                  <span>XYZ company Private Limited</span>
                                </p>
                              </Grid>
                              <Grid xs={6} xl={3}>
                                <p className="sm-font">
                                  Industry - Sub-industry
                                  <span>Information Technology-Production</span>
                                </p>
                              </Grid>
                              <Grid xs={6} xl={3}>
                                <p className="sm-font">
                                  Tax Id<span>1234567890</span>
                                </p>
                              </Grid>
                              <Grid xs={6} xl={3}>
                                <p className="sm-font">
                                  Company ID <span>XQ678</span>
                                </p>
                              </Grid>
                            </Grid>
                            <Grid container className="ParentOrgSection">
                              <Grid xs={3}>
                                <p className="mobile">+91 98765 43210</p>
                              </Grid>
                              <Grid xs={3}>
                                <p className="email">xyz.asfa@domain.com</p>
                              </Grid>
                              <Grid xs={6}>
                                <p className="address">
                                  address 1, street no, area, phase, city,
                                  state, country - 123456
                                </p>
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      </>
                    )}
                  </Box>
                </>
              ) : null}

              {productTabsStatus == "contacts" ? (
                <>
                  <Box>
                    {/* <Grid xs={12} > */}
                    <Grid container>
                      <Grid xs={12}>
                        <SpocTable />
                      </Grid>
                    </Grid>
                    {/* </Grid> */}
                  </Box>
                </>
              ) : null}

              {productTabsStatus == "logs" ? (
                <>
                  <LogsTable />
                </>
              ) : null}

              {productTabsStatus == "settings" ? (
                <>
                  <Box style={{ margin: "0px 12px" }}>
                    <Grid container>
                      <Grid xs={12} className="detailSection pt-4 pb-4">
                        <Grid
                          container
                          spacing={3}
                          className="emp_switchFields"
                        >
                          <Grid xs={4} display={"flex"} alignItems="center">
                            <span>Enable Employer Portal</span>
                            <input
                              type="checkbox"
                              className="switch"
                              onClick={handleClick}
                            />
                          </Grid>
                          <Grid xs={4} display={"flex"} alignItems="center">
                            <span> Enable Employer Portal</span>
                            <input
                              type="checkbox"
                              className="switch"
                              onClick={handleClick}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" style={{ margin: "0px 12px" }}>
                    <div className="sectionTitle mb-0">
                      <h4>Users </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => { }}
                        >
                          Add User
                        </Link>
                      </div>
                    </div>

                    <Grid xs={12} className="detailBox2 ">
                      <Grid container padding={0}>
                        <Grid xs={12} className="innerDetailBox table">
                          <div className="settingtableview">
                            <div className="Settingstableinner">
                              <ul className="SettingstableHeader">
                                <li>
                                  Username
                                  <button className="sorting-btn">
                                    <img
                                      src="./images/sorting_btn.svg"
                                      alt=""
                                    />
                                  </button>
                                </li>
                                <li>
                                  Role Type
                                  <button className="sorting-btn">
                                    <img
                                      src="./images/sorting_btn.svg"
                                      alt=""
                                    />
                                  </button>
                                </li>
                                <li>
                                  Creation Date
                                  <button className="sorting-btn">
                                    <img
                                      src="./images/sorting_btn.svg"
                                      alt=""
                                    />
                                  </button>
                                </li>
                                <li>
                                  Creation Time
                                  <button className="sorting-btn">
                                    <img
                                      src="./images/sorting_btn.svg"
                                      alt=""
                                    />
                                  </button>
                                </li>
                                <li>
                                  Action
                                  <button className="sorting-btn">
                                    <img
                                      src="./images/sorting_btn.svg"
                                      alt=""
                                    />
                                  </button>
                                </li>
                              </ul>

                              {userData.map((data, index) => (
                                <ul className="SettingstableData">
                                  <li>{data.username}</li>
                                  <li>{data.roletype}</li>
                                  <li>{data.creationdate}</li>
                                  <li>{data.creationtime}</li>
                                  <li>
                                    <Link className="edit_address_link mr-3">
                                      <img src={data.actionbtn1} alt="" />
                                    </Link>
                                    <Link className="edit_address_link">
                                      <img src={data.actionbtn2} alt="" />
                                    </Link>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ClientDetails;
